module.exports = __webpack_public_path__ + "media/images/weekly_planner_explain-e133d2aa66c750e872472e5bd4935db8.png";